export { default as StyledTabs } from "./StyledTabs";
export { default as StyledDrawer } from "./StyledDrawer";
export { default as StyledCard } from "./StyledCard";
export { default as StyledModal } from "./StyledModal";
export { default as StyledPopover } from "./StyledPopover";
export { default as StyledSkeleton } from "./StyledSkeleton";
export { default as StyledDatePicker } from "./StyledDatePicker";
export { default as StyledRangePicker } from "./StyledRangePicker";
export { default as StyledUpload } from "./StyledUpload";
export { default as StyledDropdown } from "./StyledDropdown";
export { default as StyledMenu } from "./StyledMenu";
export { default as StyledMenuItem } from "./StyledMenuItem";




// WEBPACK FOOTER //
// ./src/components/UI/Antd/index.js